import { CSSProperties } from 'react';

type hoverParams = {
  hover:boolean
}
function ReadMore({hover}:hoverParams){

    const circleText = `
  @keyframes circleText {
    from{
        transform:rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
  }
`;

  const circleAnimation: CSSProperties = {
    animation: 'circleText 8s linear infinite'
  };

  const styleArrow: CSSProperties = {
    width: '55%',
    height: '55%',
    position: 'absolute',
    fill: '#042040',
    transform: 'rotate(-45deg)',
    transition: 'transform 0.2s ease-in-out, fill 0.2s ease-in-out, width 0.2s ease-in-out, height 0.2s ease-in-out',
  };
  
  const hoverStyleArrow: CSSProperties = {
    transform: 'rotate(0deg)',
    fill: 'white',
    width: '40%',
    height: '40%',
  };

  const pathSVG: CSSProperties = {
    position:'absolute',
    backgroundColor:'#FED90F',
    clipPath: 'circle(0%)',
    width:'100%',
    height:'100%',
    borderRadius:'100%',
    transition:'clip-path 0.4s ease-in-out, opacity 0.2s ease-in-out',
    opacity:'0',
  };

  const hoverPathSVG: CSSProperties = {
    clipPath: 'circle(100%)',
    opacity:'1'
  };



    return(
        <div
             className={`border-[2.5px] ${hover ? "border-[#FED90F]" : "border-[#042040]"} w-[60px] h-[60px] rounded-full flex justify-center items-center relative cursor-pointer group bg-white`}>
            <div style={hover ? { ...pathSVG, ...hoverPathSVG } : pathSVG}></div>

            <svg style={circleAnimation} className="absolute w-[72%] h-[72%]" viewBox="0 0 100 100" overflow="visible"><path id="curve-wnxkz4" d="M 0 50 L 0 50 A 1 1 0 0 1 100 50 L 100 50 L 100 50 A 1 1 0 0 1 0 50 L 0 50" strokeWidth="none" fill="transparent"></path><text><textPath className="your-color" href="#curve-wnxkz4" startOffset="0" textLength="300" style={{ fontSize: '14px', fontFamily: 'Arial', fontWeight: 700, wordSpacing: '3px', letterSpacing: '2px', fill:'white' }}>DECOUVRIR DECOUVRIR DECOUVRIR</textPath></text></svg>
        
        <svg style={hover ? { ...styleArrow, ...hoverStyleArrow } : styleArrow}
 xmlns="http://www.w3.org/2000/svg" focusable="false" viewBox="0 0 24 24"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path></svg>
        

        <style>{circleText}</style>
        
        </div>
    )
}

export default ReadMore;